import { useState } from 'react';
import { ColourGradingClient, ColourGradingDTO } from '../services/apiClient';
import { API_BASE_URL } from '../config/config';
import axiosInstance from '../services/axiosInstance';

export const useColourGradingApi = () => {
    const apiClient = new ColourGradingClient(API_BASE_URL, axiosInstance);

    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const create = async (data: ColourGradingDTO) => {
        setIsLoading(true);
        try {
            await apiClient.createColourGrading(data);
        } catch (err: any) {
            setError(err.message || 'Error creating ColourGrading');
        } finally {
            setIsLoading(false);
        }
    };

    const edit = async (id: string, data: ColourGradingDTO) => {
        setIsLoading(true);
        try {
            await apiClient.updateColourGrading(id, data);
        } catch (err: any) {
            setError(err.message || 'Error updating ColourGrading');
        } finally {
            setIsLoading(false);
        }
    };

    const getById = async (id: string) => {
        setIsLoading(true);
        try {
            return await apiClient.getColourGradingById(id);
        } catch (err: any) {
            setError(err.message || 'Error fetching ColourGrading');
        } finally {
            setIsLoading(false);
        }
    };

    const search = async (filters: any) => {
        setIsLoading(true);
        try {
            return await apiClient.searchColourGradings(filters);
        } catch (err: any) {
            setError(err.message || 'Error searching ColourGradings');
        } finally {
            setIsLoading(false);
        }
    };

    const remove = async (id: string) => {
        setIsLoading(true);
        try {
            await apiClient.deleteColourGrading(id);
        } catch (err: any) {
            setError(err.message || 'Error deleting ColourGrading');
        } finally {
            setIsLoading(false);
        }
    };

    return { create, edit, getById, search, remove, isLoading, error };
};